import { render, staticRenderFns } from "./PbDateTime.vue?vue&type=template&id=2d520a28&"
import script from "./PbDateTime.vue?vue&type=script&lang=js&"
export * from "./PbDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports